import { TextCSSStyleImpl } from './textcss';
import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { TextViewImpl } from './textview';
import { UIComponentCSSStyle } from '../uicomponentcss';

export interface TextComponentProps extends UIComponentProps
{
    id: string;
    value: string;
    placeholder: string;
    inputType: string;
    isRequired: boolean;
    maxLength: string;
    emptyErrorMsg: string;
    isDisabled:boolean;
    label: string;
    onChange?(data:string): void;

}

export interface TextComponentState extends UIComponentState
{
    value: string;
    errorMessage: undefined | string;
    class: string;
}

export interface TextComponentHandler extends UIComponentHandler
{
    onChange(data: string): void;
}

export class TextComponent extends UIComponentImpl<TextComponentProps, TextComponentState, UIDataModel> 
       implements TextComponentHandler
{
    constructor(props: TextComponentProps)
    {
        super(props);

        this.state = {value: props.value, errorMessage: undefined, class: ""};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TextViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TextCSSStyleImpl(applicationContext);
    }

    setErrorMessage(errorMesssage: string)
    {
        this.setState({errorMessage: errorMesssage});
    }

    UNSAFE_componentWillReceiveProps(newProps:TextComponentProps)
    {
        this.setState({value: newProps.value});
    }

    onChange(data: string): void 
    {
        this.props.onChange !== undefined && this.props.onChange(data.slice(0, +this.props.maxLength));

        if (data !== '') {
            this.setState({value: data.slice(0, +this.props.maxLength), class: "on"});
        }
        else {
                this.setState({value: data.slice(0, +this.props.maxLength), class: ""});
        }
    }

    getData(): string
    {
        return this.state.value;
    }

    clearData()
    {
        this.setState({value: "", errorMessage: undefined});
    }

    validate(): boolean
    {
        if(this.props.isRequired && this.state.value.length === 0)
        {
            this.setState({errorMessage: this.props.emptyErrorMsg});

            return false;
        }
        else
        {
            this.setState({errorMessage: undefined});

            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/textcomponent.tsx